"use client";

import React from "react";

export interface LinkedAccount {
  client_code: string;
  name: string;
  is_primary: boolean;
  account_type?: string;
}

interface AccountPickerModalProps {
  accounts: LinkedAccount[];
  onSelect: (clientCode: string) => void;
}

const accountTypeLabel = (account: LinkedAccount): string => {
  if (!account.account_type) return "Individual Account";
  return `${account.account_type} Account`;
};

const AccountPickerModal: React.FC<AccountPickerModalProps> = ({ accounts, onSelect }) => {
  return (
    <div style={{
      position: "fixed", inset: 0,
      background: "rgba(0,0,0,0.4)",
      backdropFilter: "blur(4px)",
      display: "flex", alignItems: "center", justifyContent: "center",
      zIndex: 1000,
    }}>
      <div style={{
        background: "#fff",
        borderRadius: "16px",
        padding: "24px",
        width: "100%",
        maxWidth: "440px",
        boxShadow: "0 8px 40px rgba(0,0,0,0.18)",
        display: "flex",
        flexDirection: "column",
        gap: "20px",
      }}>
        {/* Header */}
        <div style={{ display: "flex", flexDirection: "column", gap: "4px" }}>
          <h2 style={{ margin: 0, fontSize: "20px", fontWeight: 700, lineHeight: "28px", color: "#0f172a" }}>
            Choose Primary Account
          </h2>
          <p style={{ margin: 0, fontSize: "14px", lineHeight: "20px", color: "#64748b" }}>
            You can switch your account and update your primary from the profile section
          </p>
        </div>

        {/* Account rows */}
        <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
          {accounts.map((account) => (
            <button
              key={account.client_code}
              type="button"
              onClick={() => onSelect(account.client_code)}
              style={{
                display: "flex", alignItems: "center", justifyContent: "space-between",
                width: "100%", textAlign: "left",
                padding: "16px",
                border: "1px solid #e2e8f0",
                borderRadius: "12px",
                background: "#fff",
                cursor: "pointer",
                boxSizing: "border-box",
                transition: "border-color 0.15s, background 0.15s",
              }}
              onMouseEnter={(e) => {
                (e.currentTarget as HTMLButtonElement).style.borderColor = "#064ad3";
                (e.currentTarget as HTMLButtonElement).style.background = "#f8fafc";
              }}
              onMouseLeave={(e) => {
                (e.currentTarget as HTMLButtonElement).style.borderColor = "#e2e8f0";
                (e.currentTarget as HTMLButtonElement).style.background = "#fff";
              }}
            >
              <div style={{ display: "flex", flexDirection: "column", gap: "4px", minWidth: 0 }}>
                {/* Account type chip */}
                <span style={{
                  display: "inline-flex", alignSelf: "flex-start",
                  padding: "2px 10px",
                  borderRadius: "999px",
                  fontSize: "12px", fontWeight: 500, lineHeight: "16px",
                  background: "#f1f5f9", color: "#475569",
                }}>
                  {accountTypeLabel(account)}
                </span>
                {/* Name */}
                <span style={{
                  fontSize: "16px", fontWeight: 600, lineHeight: "24px",
                  color: "#0f172a",
                  overflow: "hidden", textOverflow: "ellipsis", whiteSpace: "nowrap",
                }}>
                  {account.name || account.client_code}
                </span>
                {/* Client Code */}
                <span style={{ fontSize: "13px", lineHeight: "16px", color: "#94a3b8" }}>
                  Client Code{" "}
                  <span style={{ fontWeight: 500, color: "#475569" }}>{account.client_code}</span>
                </span>
              </div>

              {/* Right chevron */}
              <svg
                width="18" height="18" viewBox="0 0 24 24" fill="none"
                stroke="#94a3b8" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
                style={{ flexShrink: 0, marginLeft: "12px" }}
              >
                <polyline points="9 18 15 12 9 6" />
              </svg>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AccountPickerModal;
